// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__popover--W9lHN {
  height: auto;
  position: relative;
  z-index: 1;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  gap: 0.75rem;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #fafafa;
  width: 240px;
  box-shadow: 0 0.25rem 0.5rem -0.125rem rgba(12, 13, 13, 0.1), 0 0 0.25rem -0.125rem rgba(12, 13, 13, 0.06);
  box-shadow: 0 4px 8px -2px rgba(12, 13, 13, 0.1), 0px 0px 4px -2px rgba(12, 13, 13, 0.06);
}
.style__popoverTitle--LAOl_ {
  color: #7d8287;
  white-space: nowrap;
}
.style__noArrow--Cs_v4::after {
  display: none;
}
.style__popoverTop--IOdQt {
  bottom: 5rem;
  left: -6rem;
}
.style__popoverLeft--PZpU3 {
  bottom: 2.5rem;
  left: -16rem;
}
.style__popoverTop--IOdQt::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  top: 10px;
  left: 50%;
  border: 7px solid #fff;
  transform-origin: 0 0;
  transform: rotate(225deg);
  box-shadow: 4px 4px 4px 0 rgba(12, 13, 13, 0.04);
}
.style__popoverBottom--k2eRK::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  bottom: -4px;
  left: 91%;
  border: 7px solid #fff;
  transform-origin: 0 0;
  transform: rotate(45deg);
  box-shadow: 4px 4px 4px 0 rgba(12, 13, 13, 0.04);
}
.style__popoverLeft--PZpU3::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  top: 22px;
  left: 95%;
  border: 7px solid #fff;
  transform-origin: 0 0;
  transform: rotate(-45deg);
  box-shadow: 4px 4px 4px 0 rgba(12, 13, 13, 0.04);
}
`, "",{"version":3,"sources":["webpack://./../components/src/Popover/style.less","webpack://./../components/src/shadows.less"],"names":[],"mappings":"AAGA;EAEI,YAAA;EACA,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;ECHF,0GAAA;EAKA,yFAAA;ADHF;AAZA;EAkBI,cAAA;EACA,mBAAA;AAHJ;AAhBA;EAuBI,aAAA;AAJJ;AAnBA;EA2BI,YAAA;EACA,WAAA;AALJ;AAvBA;EAgCI,cAAA;EACA,YAAA;AANJ;AA3BA;EAqCI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gDAAA;AAPJ;AAvCA;EAkDI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gDAAA;AARJ;AAnDA;EA+DI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gDAAA;AATJ","sourcesContent":["@import '../shadows';\n@import '../spacing';\n\n:local {\n  .popover {\n    height: auto;\n    position: relative;\n    z-index: 1;\n    border-radius: @spacing-50;\n    display: flex;\n    flex-direction: column;\n    padding: @spacing-75;\n    gap: @spacing-75;\n    box-sizing: border-box;\n    background-color: @color-white;\n    border: 1px solid #fafafa;\n    width: 240px;\n    .sys-elevation-shadow-level2();\n  }\n\n  .popoverTitle {\n    color: @color-asphalt-grey-050;\n    white-space: nowrap;\n  }\n\n  .noArrow::after {\n    display: none;\n  }\n\n  .popoverTop {\n    bottom: 5rem;\n    left: -6rem;\n  }\n\n  .popoverLeft {\n    bottom: 2.5rem;\n    left: -16rem;\n  }\n\n  .popoverTop::after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    top: 10px;\n    left: 50%;\n    border: 7px solid #fff;\n    transform-origin: 0 0;\n    transform: rotate(225deg);\n    box-shadow: 4px 4px 4px 0 rgba(12, 13, 13, 0.04);\n  }\n\n  .popoverBottom::after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    bottom: -4px;\n    left: 91%;\n    border: 7px solid #fff;\n    transform-origin: 0 0;\n    transform: rotate(45deg);\n    box-shadow: 4px 4px 4px 0 fade(@color-asphalt-grey-005, 4%);\n  }\n\n  .popoverLeft::after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    top: 22px;\n    left: 95%;\n    border: 7px solid #fff;\n    transform-origin: 0 0;\n    transform: rotate(-45deg);\n    box-shadow: 4px 4px 4px 0 fade(@color-asphalt-grey-005, 4%);\n  }\n}\n","@import 'colors';\n@import 'spacing';\n\n.sys-elevation-shadow-level0() {\n  box-shadow: 0 0 0 0 @color-asphalt-grey-005;\n}\n\n.sys-elevation-shadow-level1() {\n  box-shadow: 0 1px 3px 0 fade(@color-asphalt-grey-005, 10%),\n    0 1px @spacing-15 0 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 @spacing-25 @spacing-50 -@spacing-15 fade(@color-asphalt-grey-005, 10%),\n    0 0 @spacing-25 -@spacing-15 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 4px 8px -2px fade(@color-asphalt-grey-005, 10%),\n    0px 0px 4px -2px fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level3() {\n  box-shadow: 0 @spacing-75 @spacing-100 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-25 6px -@spacing-15 fade(@color-asphalt-grey-005, 5%);\n}\n\n.sys-elevation-shadow-level4() {\n  box-shadow: 0 20px @spacing-150 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-50 @spacing-50 -@spacing-25 fade(@color-asphalt-grey-005, 4%);\n}\n\n.sys-elevation-shadow-level5() {\n  box-shadow: 0 @spacing-150 @spacing-300 -@spacing-75 fade(@color-asphalt-grey-005, 15%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `style__popover--W9lHN`,
	"popoverTitle": `style__popoverTitle--LAOl_`,
	"noArrow": `style__noArrow--Cs_v4`,
	"popoverTop": `style__popoverTop--IOdQt`,
	"popoverLeft": `style__popoverLeft--PZpU3`,
	"popoverBottom": `style__popoverBottom--k2eRK`
};
export default ___CSS_LOADER_EXPORT___;
